import { Component, EventEmitter, OnInit, Output } from "@angular/core";

@Component({
	selector: "app-terms-and-conditions",
	templateUrl: "./terms-and-conditions.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class TermsAndConditionsComponent implements OnInit {
	@Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
	constructor() {}

	ngOnInit(): void {}
}
